import { Navigate, useParams } from "react-router-dom";

// Redirects legacy /partners/guaranteed-rent/:city URLs to the new /guaranteed-rent/:city/ routes.
export default function LegacyGuaranteedRentRedirect() {
  const { city } = useParams();
  const slug = (city || "").toLowerCase().replace(/\/+$/, "");
  return <Navigate to={`/guaranteed-rent/${slug}/`} replace />;
}